import React, { useState } from 'react';

export default function StreamOverlay(props) {
	return <div>Scoreboard</div>;
}
